<template>
  <div v-loading.body="loading">
    <div
      v-if="resData"
      class="row"
      :gutter="20"
      type="flex"
      align="middle"
      justify="start"
    >
      <div
        v-for="item in origin_list"
        v-if="item.origin_id !== -1"
        :key="item.origin_id"
        class="status"
        :class="{ active: origin === item.origin_id }"
        @click="selectOrigin(item.origin_id)"
      >
        {{ item.origin_name }}
      </div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-select
                    v-model="search_type"
                    placeholder=""
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in search_options"
                      :key="item.key"
                      :label="item.name"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item style="margin-left: -15px; width: 165px">
                  <el-input
                    v-model="search_value"
                    placeholder="请输入搜索内容"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.billing_mehtod"
                    placeholder="计费方式"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in billing_mehtods"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.type"
                    placeholder="理赔类型"
                    style="width: 150px"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.type"
                      :key="item.claims_type_id"
                      :label="item.title"
                      :value="item.claims_type_id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="提交时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="审核时间：">
                  <el-date-picker
                    v-model="form.check_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="理赔月份：">
                  <el-date-picker
                    v-model="form.shipping_month"
                    format="yyyy-MM"
                    type="month"
                    placeholder="选择月"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.status"
                    placeholder="状态"
                    style="width: 150px"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in status_options"
                      :key="item.key"
                      :label="item.name"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="" @click="reset">重置</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-button
            slot="trigger"
            style="margin-left: auto"
            size="mini"
            type="primary"
            @click="dialogFormVisible = true"
            >批量审核</el-button
          >
          <el-button
            slot="trigger"
            style=""
            size="mini"
            type="primary"
            @click="outputdetail"
            >理赔明细导出</el-button
          >
          <el-button
            slot="trigger"
            style=""
            size="mini"
            type="primary"
            @click="output"
            >导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            :cell-class-name="addColor"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              align="center"
              prop="claims_id"
              label="理赔批次号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="work_count"
              label="工单数量"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="num"
              label="商品数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="refund_money"
              label="退款金额"
            ></el-table-column>
            <el-table-column align="center" label="理赔类型">
              <template slot-scope="scope">
                {{ scope.row.f_claims_type }}/
                {{ scope.row.claims_type }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop=""
              label="计费方式/计费比例/商品理赔"
            >
              <template slot-scope="scope">
                {{ scope.row.claims_billing_method }}/
                {{ scope.row.billing_rate }}/{{ scope.row.money }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="shipping_fee"
              label="理赔运费"
            ></el-table-column>
            <el-table-column align="center" prop="claims_fee" label="理赔费用">
            </el-table-column>
            <el-table-column
              align="center"
              prop="shipping_month"
              label="理赔月份"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="apply_admin"
              label="提交人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="提交时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="remark"
              label="提交备注"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="claims_detail_status"
              label="状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="check_admin"
              label="审核人"
            ></el-table-column>

            <el-table-column align="center" prop="check_time" label="审核时间">
              <template slot-scope="scope">
                <span>{{
                  scope.row.check_time == "1970-01-01 08:00:00"
                    ? ""
                    : scope.row.check_time
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="check_remark"
              label="审核备注"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="dbid"
              label="操作"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  @click="handleDetail(scope.row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>

      <el-dialog
        title="批量审核"
        :visible.sync="dialogFormVisible"
        width="30%"
        center
      >
        <el-form :model="form">
          <div style="margin-top: 20px" label="审核状态:">
            <el-radio v-model="form.batchstatus" label="2" border size="medium">
              通过</el-radio
            >
            <el-radio v-model="form.batchstatus" label="3" border size="medium">
              驳回</el-radio
            >
          </div>
          <el-form-item label="备注">
            <el-input
              v-model="form.check_remark"
              type="text"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="batchCheck">确 定</el-button>
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      fileList: [],
      clear_action: "",
      logVisible: false,
      clearVisible: false,
      resData: {},
      form: {
        pagesize: 50,
      },
      search_type: "claims_id",
      search_options: [
        { key: "claims_id", name: "理赔批次号" },
        { key: "apply_admin", name: "申请人" },
        { key: "check_admin", name: "审核人" },
        { key: "work_id", name: "工单 ID" },
      ],
      status_options: [
        { key: 1, name: "待审核" },
        { key: 2, name: "审核通过" },
        { key: 3, name: "驳回" },
      ],
      billing_mehtods: [
        {
          id: 1,
          name: "按代采价",
        },
        {
          id: 2,
          name: "按平台价",
        },
      ],
      search_value: "",
      origin_list: [
        {
          origin_id: 1,
          origin_name: "广州",
        },
        {
          origin_id: 2,
          origin_name: "杭州",
        },
      ],
      origin: 1,
      space: "",
      ss_id: 0,
      loading: false,
      tableLoading: false,
      url: "/erp/claims/ClaimsList",
      curPage: 1,
      filterFold: false,
      isAll: false,
      supplyData: null,
      logcurPage: 1,
      logInfo: {},
      multipleSelection: [],
      dialogFormVisible: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    output() {
      this.form.is_excel = 2;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    outputdetail() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    selectOrigin(origin_id) {
      this.origin = origin_id;
      this.form.origin = origin_id;
      this.fetchData(true);
    },
    addColor({ row, column, columnIndex }) {
      // if (columnIndex === 15) {
      //     return 'blue-cell';
      // }
    },
    exportExcel() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      if (this.search_value != "") {
        for (const key in this.search_options) {
          this.form[this.search_options[key].key] = "";
        }
        this.form[this.search_type] = this.search_value;
      } else {
        for (const key in this.search_options) {
          this.form[this.search_options[key].key] = "";
        }
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      for (const key in val) {
        multipleSelection[key] = val[key].claims_id;
      }
      this.multipleSelection = multipleSelection;
    },
    handleDetail(row) {
      const routeData = this.$router.resolve({
        name: `home/claims/detail/${row.claims_id}`,
      });
      window.open(routeData.href + routeData.route.name, "_blank");
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },

    search() {
      this.form.page = 1;
      this.loading = true;
      this.fetchData(true);
    },

    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    reset() {
      this.search_value = "";
      this.form = {};
    },
    batchCheck() {
      if (this.multipleSelection.length == 0) {
        this.$message.error("请先勾选理赔单");
        return;
      }
      const url = "/erp/claims/batchCheck";
      this.form.claims_ids = this.multipleSelection;
      this.$http.post(url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success("操作成功");
          this.dialogFormVisible = false;
          this.fetchData();
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/claims/ClaimsList.vue